import { SEARCH_BOT_META_CONTENT, SEARCH_BOT_META_NAME } from '@lentau/ui-kit/core/ssr/search-bot-flag.constants';

/** Accepts real `Window` / app window refs without TS2559 weak-type errors. */
export type RuntimeRecoverySkipWindow = Window | { __IS_SEARCH_BOT__?: boolean };

export function hasSearchBotWindowFlag(windowRef: RuntimeRecoverySkipWindow | null | undefined): boolean {
  if (windowRef == null) {
    return false;
  }

  return (windowRef as { __IS_SEARCH_BOT__?: boolean }).__IS_SEARCH_BOT__ === true;
}

export function hasSearchBotMetaTag(documentRef: Document | null | undefined): boolean {
  if (!documentRef || typeof documentRef.querySelector !== 'function') {
    return false;
  }

  const metaSelector: string = `meta[name="${SEARCH_BOT_META_NAME}"][content="${SEARCH_BOT_META_CONTENT}"]`;
  const meta: Element | null = documentRef.querySelector(metaSelector);

  return meta !== null;
}

export function shouldSkipRuntimeRecoveryFallback(
  windowRef: RuntimeRecoverySkipWindow | null | undefined,
  documentRef: Document | null | undefined
): boolean {
  return hasSearchBotWindowFlag(windowRef) || hasSearchBotMetaTag(documentRef);
}
